"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const WorkflowModule = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    stepCallback = () => null,
    stepResponseCallback = stepResponse => {
      return null;
    },
    errorMessagePreProcessor = message => {
      return message;
    },
    // nextButtonDisabled = true,
    nextButtonTitle = 'Next',
    nextDisabledMethod
  } = _ref;
  const [loading, setLoading] = (0, _react.useState)(false);
  (0, _react.useImperativeHandle)(ref, () => ({
    setLoading: loadingArg => setLoading(loadingArg),
    getStep: () => stepCallback(),
    getNextButtonTitle: () => nextButtonTitle,
    setNextButtonDisabled: disabled => nextDisabledMethod(disabled),
    setStepResponse: stepResponse => stepResponseCallback(stepResponse),
    getProcessedErrorMessage: message => errorMessagePreProcessor(message)
  }), []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: `lds-spinner-overlay ${loading && 'is-active'}`
  }, loading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), children);
});
WorkflowModule.displayName = 'WorkflowModule';
WorkflowModule.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  stepCallback: _propTypes.default.func,
  stepResponseCallback: _propTypes.default.func,
  errorMessagePreProcessor: _propTypes.default.func,
  nextButtonDisabled: _propTypes.default.bool,
  nextButtonTitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  nextDisabledMethod: _propTypes.default.func
};
var _default = exports.default = WorkflowModule;
//# sourceMappingURL=WorkflowModule.js.map